import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHouse } from '@fortawesome/free-solid-svg-icons';

const routeLabels: Record<string, string> = {
  Account: 'Acceso privado',
  About: 'Acerca de',
  Gallery: 'Galería',
  Contact: 'Contacto',
  Prices: 'Precios',
  InformacionDental: 'Información Dental',
  AdminPanel: 'Área interna',
  Agenda: 'Agenda',
  Pacientes: 'Pacientes',
};

interface BreadcrumbProps {
  variant: 'container' | 'admin';
}

const toTitleCase = (value: string): string => {
  return value.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ variant }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const isHomePage = pathSegments.length === 0;

  return (
    <nav className={`breadcrumb-shell breadcrumb-shell-${variant}`} aria-label="Ruta de navegación">
      <ol className="breadcrumb-list">
        <li aria-current={isHomePage ? 'page' : undefined}>
          {isHomePage ? (
            <span>
              <FontAwesomeIcon icon={faHouse} />
              <span>Portada</span>
            </span>
          ) : (
            <Link to="/" aria-label="Ir a portada">
              <FontAwesomeIcon icon={faHouse} />
              <span>Portada</span>
            </Link>
          )}
        </li>
        {pathSegments.map((segment, index) => {
          const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
          const isLast = index === pathSegments.length - 1;
          const label = routeLabels[segment] || toTitleCase(decodeURIComponent(segment));
          return (
            <li key={path} aria-current={isLast ? 'page' : undefined}>
              <FontAwesomeIcon className="breadcrumb-separator" icon={faChevronRight} />
              {isLast ? <span>{label}</span> : <Link to={path}>{label}</Link>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
